<!--<c-footer>-->
<div>
  <span><a href="javascript:viod(0)">TCC A-MED</a> &copy; 2021</span>
</div>
<!--</c-footer>-->